var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.83325C8.27614 2.83325 8.5 3.05711 8.5 3.33325V12.6666C8.5 12.9427 8.27614 13.1666 8 13.1666C7.72386 13.1666 7.5 12.9427 7.5 12.6666V3.33325C7.5 3.05711 7.72386 2.83325 8 2.83325Z",
    fill: "#5E3FF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83337 8C2.83337 7.72386 3.05723 7.5 3.33337 7.5H12.6667C12.9428 7.5 13.1667 7.72386 13.1667 8C13.1667 8.27614 12.9428 8.5 12.6667 8.5H3.33337C3.05723 8.5 2.83337 8.27614 2.83337 8Z",
    fill: "#5E3FF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusText);
export default __webpack_public_path__ + "static/media/PlusText.e3fbd798c5b46eb5f382e1ee362d23b9.svg";
export { ForwardRef as ReactComponent };